module.exports = __webpack_public_path__ + "img/midDialogBg.ed852152.png";